import { useContext, useEffect, useState } from "react";
import { IsTeacher, IsLectureTeacher } from "../../../components/exl/CourseHelperFunctions";
import { GetCourseById } from "../../../components/exl/requests/CourseRequests";
import { GetBookingsByCourseId } from "../../../components/exl/requests/BookingRequests";
import { DataContext } from "../../../store";
import { DataContext as SharedDataContext} from '../../../.././src/./stores/crm-store'
import { navigate } from 'hookrouter'

const getCourseData = async (id, updateLoadingState, updateCourseState, sharedDispatch) => {
  updateLoadingState(true);
  const courseResponse = await GetCourseById(id);

  if(courseResponse === null) {
    navigate('/exlCourses');
    sharedDispatch({type: 'SHOW_ERROR_TOAST'});
  }

  updateCourseState(courseResponse);
  updateLoadingState(false);
};

const getCourseBookings = async (id, updateCancelledBookings) => {
    const bookings = await GetBookingsByCourseId(id);
    updateCancelledBookings(bookings.filter(b => b.status === 2));
}

const getCourseUser = (user, updateCourseUserState, course) => {
    let booking = null;
    if (course.bookings !== null) {
        booking = course?.bookings.find((b) =>
            b.coaEmpId.toUpperCase() === user.id.toUpperCase());
    }
  const isTeacher = IsTeacher(course, user);
  const isLectureTeacher = IsLectureTeacher(course.lectures, user);
  const isExlAdmin = user.isExlAdmin;
  const isNormalUser = user.isExlUser;
  const id = user.id;

  updateCourseUserState({
    isRegistered: !!booking,
    teacherPermission: isTeacher,
    lectureTeacherPermission: isLectureTeacher,
    editPermission: isExlAdmin,
    normalUserPermission: isNormalUser,
    booking: booking,
    coaEmpId: id,
  });
}

export default function useCourseDetails(courseId) {
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [courseUser, setCourseUser] = useState(null);
  const [cancelledBookings, setCancelledBookings] = useState([]);

  const {
    store: { user },
  } = useContext(DataContext);

  const { dispatch: sharedDispatch } = useContext(SharedDataContext);

  useEffect(() => {
    if (!course || course?.id !== courseId)
      getCourseData(courseId, setLoading, setCourse, sharedDispatch);

    if (user && course) 
      getCourseUser(user, setCourseUser, course);

  }, [courseId, user, course]);

    useEffect(() => {
        if (courseUser?.editPermission) {
            getCourseBookings(course.id, setCancelledBookings);
        }
    }, [courseUser]);

  const refreshCourseData = () => {
    getCourseData(courseId, setLoading, setCourse);
  }

  return {
    course,
    loading,
    courseUser,
    cancelledBookings,
    refreshCourseData
  }
}